import React, {Component, createElement} from 'react'
import PropTypes from 'prop-types'
import {mutationSubscribe} from '@republic/foundation/browser/mutation'
import {screenSubscribe} from '@republic/foundation/browser/screen'
import {scrollBottom, scrollTop, scrollSubscribe} from '@republic/foundation/browser/scroll'
import {each, find, reduce} from '@republic/foundation/lang/array'
import {isEqual, isNumber, isString} from '@republic/foundation/lang/is'
import {keys, owns} from '@republic/foundation/lang/object'
import {config} from '../utils/config'
import {isNative} from '../utils/is'
import {omit} from '../utils/lang'

// TODO pull in versions of screen, scroll and mutation that have react native support

const
    breakpoints = config('Breakpoints'),

    native = isNative(),

    listeners = {
        mutate: mutationSubscribe.mutated,
        screen: screenSubscribe.updated,
        scroll: scrollSubscribe.updated
    },

    types = {
        children: PropTypes.func.isRequired,
        visibility: PropTypes.bool,
        leaps: (
            PropTypes.arrayOf(
                PropTypes.oneOfType([
                    PropTypes.object.isRequired,
                    PropTypes.arrayOf(
                        PropTypes.oneOfType([
                            PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
                            PropTypes.object.isRequired
                        ]))
                ]).isRequired))
    },

    Quantum = (
        class Quantum extends Component {
            static propTypes = types

            constructor(props) {
                super(props)
                this.ref = React.createRef()
                this.state = {values: []}
                this.unmounting = false
                this.quanta = {
                    leaps: {
                        subscriptions: {
                            mutate: null,
                            screen: null
                        },
                        value: []
                    },
                    visibility: {
                        subscriptions: {
                            mutate: null,
                            scroll: null
                        },
                        value: false
                    }
                }
            }

            create = (key, callback) => {
                if (owns(this.props, key)) {
                    if (this.props[key]) {
                        each(keys(this.quanta[key].subscriptions), subscription => {
                            if (!this.quanta[key].subscriptions[subscription]) {
                                this.quanta[key].subscriptions[subscription] = listeners[subscription](callback)
                            }
                        })
                    } else {
                        this.destroy(key)
                    }
                    callback()
                }
            }

            destroy = key => {
                each(keys(this.quanta[key].subscriptions), _key => {
                    if (this.quanta[key].subscriptions[_key]) {
                        this.quanta[key].subscriptions[_key]()
                        this.quanta[key].subscriptions[_key] = null
                    }
                })
            }

            update = () => {
                const values = {
                    ...owns(this.props, 'leaps') ? this.quanta.leaps.value : {},
                    ...owns(this.props, 'visibility') ? {visibility: this.quanta.visibility.value} : {},
                }

                if (!this.unmounting && !isEqual(this.state.values, values)) {
                    this.setState({values})
                }
            }

            onLayout = ({nativeEvent}) => {
                this.whichWidth(nativeEvent.layout.width)
            }

            getWidth = () => {
                if (!native) {
                    this.whichWidth(this.ref.current.getBoundingClientRect().width)
                }
            }

            whichWidth = width => {
                const [mobile, ...leaps] = this.props.leaps

                this.quanta.leaps.value = (
                    reduce(
                        leaps,
                        (value, [breakpoint, cascade, nonCascade], i) => {
                            const named = isString(breakpoint) && find(breakpoints, ([_width, name]) => name === breakpoint)

                            breakpoint = (
                                isNumber(breakpoint) ?
                                    breakpoint :
                                    // look for named breakpoints if string
                                    named ?
                                        named[0] :
                                        parseInt(breakpoint.replace(/\D/g,''), 10))

                            if (width >= breakpoint) {
                                value = (
                                    Object.assign(
                                        {},
                                        value,
                                        cascade,
                                        nonCascade &&
                                        // last breakpoint OR width < next breakpoint
                                        (i === leaps.length - 1 || width < leaps[i + 1][0]) ?
                                            nonCascade :
                                            {}))
                            }
                            return value
                        },
                        mobile))
                this.update()
            }

            isVisible = () => {
                const element = this.ref.current

                this.quanta.visibility.value = !!(
                    element &&
                    scrollBottom(element) > scrollTop() &&
                    scrollTop(element) < scrollBottom())
                this.update()
            }

            componentDidMount() {
                this.create('leaps', this.getWidth)
                this.create('visibility', this.isVisible)
            }

            componentDidUpdate() {
                this.create('leaps', this.getWidth)
                this.create('visibility', this.isVisible)
            }

            componentWillUnmount() {
                this.unmounting = true
                this.destroy('visibility')
                this.destroy('leaps')
            }

            render() {
                return (
                    createElement(
                        config('Particle').tag,
                        {
                            ...native ? {onLayout: this.onLayout} : {},
                            className: 'bits-quantum',
                            ref: this.ref,
                            ...omit(this.props, keys(types))
                        },
                        this.props.children(this.state.values)))
            }
        })

export default Quantum
